import { viewportBreakpoints } from '@fabric-app/ui/constants/breakpoints';
import { mediaTablet, mediaDesktop } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { motion } from 'framer-motion';
import { styled, css } from 'styled-components';

const Closer = styled.div.withConfig({
  displayName: "ExpandedFdocElements__Closer",
  componentId: "sc-b746345c-0"
})([
  `position:absolute;top:0;left:0;right:0;bottom:0;z-index:-5;`
]);
const ContentWrapper = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ContentWrapper",
  componentId: "sc-b746345c-1"
})([
  `display:flex;flex:1;height:100%;margin-left:auto;margin-right:auto;max-width:100%;position:relative;z-index:5;&[data-content-bookmark='true']{max-width:700px;max-height:800px;}&[data-content-pdf='true']{max-width:min(calc(100dvw - 150px),1200px);}&[data-content-no-preview='true']{width:445px;height:496px;max-height:496px;max-width:445px;}&[data-content-audio='true']{width:600px;max-width:600px;height:400px;max-height:400px;`,
  `{width:100%;height:100%;max-height:100%;max-width:100%;}}&[data-content-image='true']{max-height:80%;height:auto;padding:0;}&[data-content-image-loading='true']{width:auto;}&[data-content-notepad='true']{max-width:900px;`,
  `{max-width:100%;}}&[data-no-gestures='true']{pointer-events:none;}&[data-fullscreen='true']{top:0;left:0;right:0;bottom:0;position:fixed;width:100%;height:100%;max-width:100%;max-height:100%;padding:0;}`,
  `{padding:0;&[data-content-pdf='true'],&[data-content-bookmark='true'],&[data-content-no-preview='true'],&[data-content-image='true']{width:100%;height:100%;max-height:100%;max-width:100%;min-width:100%;min-height:100%;}}`
], mediaTablet, mediaTablet, mediaTablet);
const ItemPreviewContentHeader = styled.header.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewContentHeader",
  componentId: "sc-b746345c-2"
})([
  `display:flex;align-items:center;justify-content:space-between;height:70px;min-height:70px;border-top-left-radius:20px;border-top-right-radius:20px;`,
  ` box-shadow:0px 4px 4px rgba(0,0,0,0.02),0px 4px 25px rgba(0,0,0,0.05);border:1px solid var(--fabric-color-border-primary);background:var(--fabric-color-bg-primary);margin:-1px -1px 0 -1px;gap:30px;[data-content-no-preview='true'] &{background:none;border:none;box-shadow:none;}padding:4px 16px;border-bottom:1px solid var(--fabric-color-border-primary);> div:first-child{display:flex;}`,
  `{padding-bottom:5px;}@media (min-width:641px) and (max-width:`,
  `){padding-right:80px;}`
], ({ isMoving }) => isMoving && css([
  `pointer-events:none;user-select:none !important;`
]), mediaTablet, viewportBreakpoints.TABLET);
const ItemPreviewContentBody = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewContentBody",
  componentId: "sc-b746345c-3"
})([
  `flex:1;display:flex;flex-direction:column;overflow:hidden;position:relative;background:var(--fabric-color-bg-primary);border-radius:20px;[data-fullscreen='true'] &,& &{border-radius:0;}& &{overflow-y:auto;}user-select:text;*{user-select:text;}max-height:100%;.tiptap_editor{padding-bottom:100px;}`
]);
const ItemPreviewSidebar = styled(motion.div).withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebar",
  componentId: "sc-b746345c-4"
})([
  `height:1px;flex-grow:100%;flex:1;z-index:40;position:relative;min-width:350px;max-width:350px;flex-shrink:0;background:`,
  `;color:white;border-radius:20px;display:flex;flex-direction:column;&[data-similar-selected='true']{padding-bottom:0px;}`,
  `{&[data-disabled='true'],&[data-desktop-sidebar-closed='true']{position:fixed;left:100vw;height:100%;}&[data-fullscreen='true']{background-color:var(--fabric-color-bg-primary);color:var(--fabric-color-text-primary);border-radius:0;border-left:1px solid var(--fabric-color-border-primary);--fabric-color-bg-assistant:var(--fabric-color-bg-primary);}}`,
  `{top:var(--safe-margin-offset-top);z-index:125;position:fixed;left:100%;border-radius:0;width:378px;background:rgba(0,0,0,0.8);&[data-active='true']{left:auto;right:0;}}`
], cssVar["color-bg-assistant"], mediaDesktop, mediaTablet);
const ItemPreviewContent = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewContent",
  componentId: "sc-b746345c-5"
})([
  `display:flex;flex-direction:column;flex:1;width:1px;flex-grow:1;max-height:100%;max-width:100%;position:relative;box-shadow:0px 4px 4px rgba(128,128,128,0.04),0px 4px 25px rgba(128,128,128,0.1);overflow:visible;border-radius:20px;`,
  `{border-radius:0;[data-content-audio='true'] &{min-height:50px;}}--corner-offset:10px;`
], mediaTablet);
const ContentMain = styled(ContentWrapper).withConfig({
  displayName: "ExpandedFdocElements__ContentMain",
  componentId: "sc-b746345c-6"
})([
  `[data-fullscreen='true'] &{padding:0;max-width:100%;max-height:100%;width:100%;height:100%;`,
  `{border-radius:0;`,
  `{border-radius:0;}}}`
], ItemPreviewContent, ItemPreviewContentHeader);
const ItemPreviewSidebarHeader = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarHeader",
  componentId: "sc-b746345c-7"
})([
  `width:100%;display:flex;flex-direction:column;gap:20px;`
]);
const ItemPreviewSidebarHeaderTitleContainer = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarHeaderTitleContainer",
  componentId: "sc-b746345c-8"
})([
  `display:none;`,
  `{[data-disabled='true'] &,[data-desktop-sidebar-closed='true'] &{background:`,
  `;display:flex;flex-direction:column;gap:8px;padding:6px;border-radius:12px;position:absolute;visibility:visible;top:50%;right:100%;transform:translateY(-50%);font-size:14px;font-weight:400;line-height:16px;}}`
], mediaDesktop, cssVar["color-bg-secondary-button"]);
const ItemPreviewSidebarHeaderTitle = styled.h3.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarHeaderTitle",
  componentId: "sc-b746345c-9"
})([
  `align-items:center;justify-content:center;gap:4px;height:42px;font-size:14px;font-weight:400;line-height:16px;letter-spacing:-0.025em;cursor:pointer;display:flex;background:#383838;flex-shrink:0;align-items:center;border-radius:10px;padding:0;display:flex;width:36px;height:30px;align-items:center;justify-content:center;&:hover{background:#848484;}&:active{background:#939393;}&[data-similar-button='true']{gap:4px;}`,
  `{[data-disabled='true'] &{cursor:not-allowed;opacity:0.3;&:hover{background:rgba(0,0,0,0.8);}}}[data-fullscreen='true'] &{color:#070707;background:rgba(`,
  `,0.03);&:hover{background:rgba(`,
  `,0.05);}&:active{background:rgba(`,
  `,0.06);}color:`,
  `;}`,
  `{display:flex;}`
], mediaDesktop, cssVar["color-bg-primary-reverse-rgb"], cssVar["color-bg-primary-reverse-rgb"], cssVar["color-bg-primary-reverse-rgb"], cssVar["color-text-primary"], mediaTablet);
const ContentHeaderControls = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ContentHeaderControls",
  componentId: "sc-b746345c-10"
})([
  `margin-left:auto;display:flex;align-items:center;gap:12px;`
]);
const ItemPreviewSidebarCommentsEditBox = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarCommentsEditBox",
  componentId: "sc-b746345c-11"
})([
  `position:absolute;bottom:100%;left:0;width:100%;z-index:2;display:flex;gap:0.875rem;height:38px;align-items:center;padding:0 1rem;background:#111;color:#fff;font-size:12.5px;`
]);
const TopHeaderControlsExtra = styled.div.withConfig({
  displayName: "ExpandedFdocElements__TopHeaderControlsExtra",
  componentId: "sc-b746345c-12"
})([
  `&:only-child{padding-right:8px;}`
]);
const ItemPreviewSplitBody = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSplitBody",
  componentId: "sc-b746345c-13"
})([
  `display:flex;flex-grow:1;min-height:0;`
]);
const ItemPreviewSidebarSimilarBadgeText = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarSimilarBadgeText",
  componentId: "sc-b746345c-14"
})([
  `color:rgba(255,255,255,0.8);`
]);
const ItemPreviewSidebarSimilarBadgeButton = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarSimilarBadgeButton",
  componentId: "sc-b746345c-15"
})([
  `position:absolute;top:-8px;right:-8px;display:flex;width:22px;height:22px;justify-content:center;align-items:center;gap:10px;border-radius:17px;border:1px solid #000;background:#787878;`
]);
const ItemPreviewSidebarSimilarBadge = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarSimilarBadge",
  componentId: "sc-b746345c-16"
})([
  `position:relative;border-radius:8px;border:1px solid rgba(194,194,194,0.2);background:#000;padding:6px;margin-left:26px;margin-top:10px;margin-bottom:10px;width:calc(100% - 26px * 2);text-align:center;span{color:rgba(255,255,255,0.6);font-family:Inter;text-align:center;font-size:12px;font-style:normal;font-weight:400;line-height:14.52px;}`
]);
const StoredFile = styled.div.withConfig({
  displayName: "ExpandedFdocElements__StoredFile",
  componentId: "sc-b746345c-17"
})([
  `display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:-70px;height:calc(100% + 70px);gap:1rem;> a{width:100%;display:flex;justify-content:center;}`
]);
const ItemPreviewSidebarCommentsEmpty = styled.div.withConfig({
  displayName: "ExpandedFdocElements__ItemPreviewSidebarCommentsEmpty",
  componentId: "sc-b746345c-18"
})([
  `margin-top:40px;color:rgba(255,255,255,0.5);text-align:center;font-size:13px;font-family:Inter,sans-serif;width:100%;display:block;[data-fullscreen='true'] &{color:`,
  `;}`
], cssVar["color-text-tertiary"]);
const ExpandedFdocElements = {
  ContentWrapper,
  ItemPreviewContentHeader,
  ItemPreviewContentBody,
  ItemPreviewSidebar,
  ItemPreviewContent,
  ContentMain,
  ItemPreviewSidebarHeader,
  ItemPreviewSidebarHeaderTitleContainer,
  ItemPreviewSidebarHeaderTitle,
  ContentHeaderControls,
  ItemPreviewSidebarCommentsEditBox,
  TopHeaderControlsExtra,
  ItemPreviewSplitBody,
  ItemPreviewSidebarSimilarBadgeText,
  ItemPreviewSidebarSimilarBadgeButton,
  ItemPreviewSidebarSimilarBadge,
  Closer,
  StoredFile,
  ItemPreviewSidebarCommentsEmpty
};

export { ExpandedFdocElements };
//# sourceMappingURL=ExpandedFdocElements.js.map
